
const $header = $('.js-header');
const $menuToggle = $('.js-menu-toggle');
const $$menuLinks = $('.js-site-menu-item');



let menuIsOpen = false;


const openMenu = () => {
  menuIsOpen = true;

  $header.addClass('is-open-menu');
  $menuToggle.addClass('is-active');
};

const closeMenu = () => {
  menuIsOpen = false;
  $header.removeClass('is-open-menu');
  $menuToggle.removeClass('is-active');
};


const header = () => {
  $menuToggle.on('click', event => {
    event.preventDefault();
    if (menuIsOpen) {
      closeMenu();
    } else {
      openMenu();
    }

  });


  $$menuLinks.each((_, el) => {

    const $link = $(el).find('a');

    $link.on('click', event => {

      const href = $link.attr('href');

      if (href.indexOf('#')) return;


      const $target = $(href);

      if (!$target.length) return;
      event.preventDefault();

      const top = $target.offset().top - $header.outerHeight();

      if (menuIsOpen) closeMenu();

      $('html, body').animate({
        scrollTop: top
      }, 1000);
    });
  });


  const checkMenuLinks = () => {

    let $activeLink = null;

    $$menuLinks.each((_, el) => {
      const $link = $(el).find('a');

      const href = $link.attr('href');

      if (href.indexOf('#')) return;

      const $target = $(href);

      if (!$target.length) return;

      const top = $target.offset().top <= $(window).scrollTop() + $header.outerHeight() + 1;

      const bottom = $target.offset().top + $target.height() >=  $(window).scrollTop() + $header.outerHeight();



      if (top && bottom) {
        $activeLink = $(el);
      }

    });
    $$menuLinks.removeClass('is-active');

    if ($activeLink) {
      $activeLink.addClass('is-active');
    }

  };


  checkMenuLinks();

  $(window).on('scroll', checkMenuLinks);

};

export default header;
